import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed bottom-4 left-4 right-4 md:left-6 md:right-6 z-[60] flex justify-center pointer-events-none",
  role: "dialog",
  "aria-live": "polite",
  "aria-label": "Çerez bildirimi"
}
const _hoisted_2 = { class: "rounded-card bg-white border border-stone p-6 md:p-7 max-w-3xl w-full pointer-events-auto" }
const _hoisted_3 = { class: "flex flex-col md:flex-row md:items-start gap-4 md:gap-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex-shrink-0 hidden md:flex" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "w-12 h-12 rounded-full bg-parchment flex items-center justify-center text-primary" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "w-6 h-6",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "1.6",
      viewBox: "0 0 24 24"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        d: "M21.17 8A10 10 0 1016 21.17M8 12h.01M12 16h.01M16 8h.01M12 8h.01M16 13h.01"
      })
    ])
  ])
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-medium tracking-label uppercase text-graphite" }, "Çerez Bildirimi"),
  /*#__PURE__*/_createElementVNode("h3", { class: "mt-2 text-lg md:text-xl font-medium text-primary leading-tight tracking-display" }, " Deneyimini iyileştirmek için çerez kullanıyoruz. "),
  /*#__PURE__*/_createElementVNode("p", { class: "mt-2 text-sm text-graphite leading-relaxed" }, [
    /*#__PURE__*/_createTextVNode(" Site içi analitik, tercih hatırlatma ve içerik kişiselleştirme için çerezler kullanıyoruz. Zorunlu çerezler her zaman aktiftir. Detaylar için "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "/privacy",
      class: "underline decoration-secondary decoration-2 underline-offset-2 hover:text-primary"
    }, "gizlilik politikamızı"),
    /*#__PURE__*/_createTextVNode(" inceleyebilirsin. ")
  ])
], -1)
const _hoisted_6 = { class: "flex flex-col sm:flex-row md:flex-col gap-2 md:w-44 md:flex-shrink-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, {
    "enter-active-class": "transition-all duration-300 ease-out",
    "enter-from-class": "opacity-0 translate-y-4",
    "enter-to-class": "opacity-100 translate-y-0",
    "leave-active-class": "transition-all duration-200 ease-in",
    "leave-from-class": "opacity-100 translate-y-0",
    "leave-to-class": "opacity-0 translate-y-4"
  }, {
    default: _withCtx(() => [
      (_ctx.visible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.accept && _ctx.accept(...args))),
                    class: "inline-flex items-center justify-center px-5 py-3 rounded-btn border border-primary bg-secondary text-primary text-sm font-medium hover:bg-primary hover:text-secondary transition-colors"
                  }, " Tümünü kabul et "),
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.reject && _ctx.reject(...args))),
                    class: "inline-flex items-center justify-center px-5 py-3 rounded-btn border border-primary text-primary text-sm font-medium hover:bg-primary hover:text-cream transition-colors"
                  }, " Reddet ")
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}